export default __webpack_public_path__ + "static/media/jugaxjugar48.ee81a984.png";